import { PropsWithChildren } from 'react';

import { ModalContext } from '../lib/hooks';
import type { IModalContext } from '../lib/hooks';

import styles from './Container.module.css';

const Container = (props: PropsWithChildren) => {
  const {
    children,
  } = props;

  const context: IModalContext = {
    containerClassName: styles.modalContainer,
  };

  return (
    <ModalContext.Provider value={context}>
      <div className={styles.modalContainer}>
        {/* The background works using only css. Look into "Container.module.css". */}
        <div className={styles.background} />
        {children}
      </div>
    </ModalContext.Provider>
  );
};

export default Container;
